import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import axios from "axios";
import React, { useEffect, useState } from "react";
import "./addTicketForm.css";
import Cookies from "universal-cookie";
import CustomToaster from "../../../../Ui/toaster/CustomToaster";
import { useNavigate } from "react-router-dom";
import SimpleBackdrop from "../../../../Ui/Loader/backdrop";
import Autocomplete from "@mui/material/Autocomplete";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { initialState, schema } from "./validations";
import { useFormik } from "formik";
import { Logger } from "../../../../Logger/Logger";


const names = [
  "aakanksha.singh@wishtreetech.com",
  "abha.gudsoorkar@wishtreetech.com",
  "abhay.chopra@wishtreetech.com",
  "abhijit.lande@wishtreetech.com",
  "aditya.bharadwaj@wishtreetech.com",
  "aditya.pandya@wishtreetech.com",
  "ajay.varur@wishtreetech.com",
  "amey.joshi@wishtreetech.com",
  "amit.majithiya@wishtreetech.com",
  "amruta.kshirsagar@wishtreetech.com",
  "anil.buddhdev@wishtreetech.com",
  "aparna.jain@wishtreetech.com",
  "aparna.wathare@wishtreetech.com",
  "aparna.lende@wishtreetech.com",
  "archana.deshmukh@wishtreetech.com",
  "bhadrik.ranpariya@wishtreetech.com",
  "bijen.sheth@wishtreetech.com",
  "chintan.mirani@wishtreetech.com",
  "darshak.chodvadiya@wishtreetech.com",
  "darshan.parekh@wishtreetech.com",
  "deepak.gadhave@wishtreetech.com",
  "deepak.kadam@wishtreetech.com",
  "devang.parekh@wishtreetech.com",
  "dhanshri.malpani@wishtreetech.com",
  "dhaval.suthar@wishtreetech.com",
  "dilip@wishtreetech.com",
  "dnyaneshwar.bhadane@wishtreetech.com",
  "drishti.patel@wishtreetech.com",
  "faiz.shaikh@wishtreetech.com",
  "falgun.goswami@wishtreetech.com",
  "g.jadhav@wishtreetech.com",
  "gaurav.makwana@wishtreetech.com",
  "het.suthar@wishtreetech.com",
  "himani.thakkar@wishtreetech.com",
  "hitesh.kumar@wishtreetech.com",
  "hrishikesh.kshirsagar@wishtreetech.com",
  "jashkumar.dhameliya@wishtreetech.com",
  "jay.pandya@wishtreetech.com",
  "kaustubh.kadav@wishtreetech.com",
  "komal.khurad@wishtreetech.com",
  "madhav.javeri@wishtreetech.com",
  "mahek.ahya@wishtreetech.com",
  "mahesh.nalawade@wishtreetech.com",
  "malav.shah@wishtreetech.com",
  "manav.shah@wishtreetech.com",
  "mayuri.yeole@wishtreetech.com",
  "meenal.salvi@wishtreetech.com",
  "misri.parikh@wishtreetech.com",
  "mohammad.bohari@wishtreetech.com",
  "mohit.salunke@wishtreetech.com",
  "mukund.kulkarni@wishtreetech.com",
  "muskaan.sharma@wishtreetech.com",
  "namrata.soyam@wishtreetech.com",
  "nasir.shaikh@wishtreetech.com",
  "neelima.lanjewar@wishtreetech.com",
  "neelu.singh@wishtreetech.com",
  "nidhi.pandya@wishtreetech.com",
  "nidhin.nambiar@wishtreetech.com",
  "nirav.acharya@wishtreetech.com",
  "nishtha.maheshwari@wishtreetech.com",
  "nitish.gupta@wishtreetech.com",
  "nutan.jadhav@wishtreetech.com",
  "omkar.jambhale@wishtreetech.com",
  "onkar.lonare@wishtreetech.com",
  "payal.ghanshani@wishtreetech.com",
  "pournima.bhoyar@wishtreetech.com",
  "prajakta.amrutkar@wishtreetech.com",
  "prajakta.ghevade@wishtreetech.com",
  "pranjali.zaware@wishtreetech.com",
  "pratik.fanse@wishtreetech.com",
  "pratiksha.dere@wishtreetech.com",
  "pratiksha.lokhande@wishtreetech.com",
  "priya.rani@wishtreetech.com",
  "priyanka.udgave@wishtreetech.com",
  "priyanka.pandita@wishtreetech.com",
  "purvesh.gandhi@wishtreetech.com",
  "rahul.patil@wishtreetech.com",
  "rajkumar.patel@wishtreetech.com",
  "ravi@wishtreetech.com",
  "rishabh.gupta@wishtreetech.com",
  "rohan.suroshi@wishtreetech.com",
  "roshan.talwekar@wishtreetech.com",
  "rupali.takpere@wishtreetech.com",
  "saakshi.chouhan@wishtreetech.com",
  "sandeep.borate@wishtreetech.com",
  "sanjaybhai.kachchhava@wishtreetech.com",
  "sharan.dooganavar@wishtreetech.com",
  "shivani.khairnar@wishtreetech.com",
  "shlok.pimpalkar@wishtreetech.com",
  "shrey.pateliya@wishtreetech.com",
  "shubhangi.garde@wishtreetech.com",
  "shweta.danej@wishtreetech.com",
  "shyam.bhadeshiya@wishtreetech.com",
  "siva.sai@wishtreetech.com",
  "sneha.kasar@wishtreetech.com",
  "snehal.dige@wishtreetech.com",
  "sonal.shendre@wishtreetech.com",
  "sonu.agrawal@wishtreetech.com",
  "soumi.dutta@wishtreetech.com",
  "suketu.naik@wishtreetech.com",
  "sumedh.koche@wishtreetech.com",
  "sumeet.shetty@wishtreetech.com",
  "supriya.karanje@wishtreetech.com",
  "suraj.malvikar@wishtreetech.com",
  "suraj.kolate@wishtreetech.com",
  "swapnali.bhosale@wishtreetech.com",
  "tanmay.shah@wishtreetech.com",
  "tejaswini.kale@wishtreetech.com",
  "vaishali.bendre@wishtreetech.com",
  "vishakha.more@wishtreetech.com",
  "vishal.prajapati@wishtreetech.com",
  "vivek.patankar@wishtreetech.com",
];

const AddTicketForm = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const {
    register,
  } = useForm({
    initialState,
    mode: "onTouched",
    resolver: yupResolver(schema),
  });

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: schema,
    onSubmit: (data) => handleSubmitForm(data),
  });

  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [subCategoryId, setSubCategoryId] = useState("");
  const [slaCategory, setSlaCategory] = useState([]);
  const [type, setType] = useState("");
  const [toaster, setToaster] = useState(false);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [variant, setVariant] = useState("");
  const [open, setOpen] = useState(false);
  const [ticket_id, setTicketID] = useState("");
  const [fileError, setFileError] = useState(false);
  const [watcherCount, setWatcherCount] = useState(false);
  const reqType = ["Incident", "Request"];
  const [categoryFlag, setcategoryFlag] = useState(false);
  const [subcategoryFlag, setsubcategoryFlag] = useState(false);
  const [watchersName, setWatchersName] = useState([]);

  const [ticketFormData, setTicketFormData] = useState({
    subject: "",
    requestType: "",
    categoryData: "",
    sub_category: "",
    status: "Open",
    severity: "",
    dateIssueData: "",
    description: "",
    host_name: "",
    manager_emails: "",
  });

  const cookies = new Cookies();
  const apiKey = cookies.get("UserLogin");
  const userDetails = cookies.get("createdBy");
  const watchersList = watchersName.filter(mail => mail != userDetails)
  const headers = {
    "Content-Type": "application/json",
    // 'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${apiKey}`,
  };
  useEffect(()=>{
    axios
      .get(`${BASE_URL}api/ticket/watchers/`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("Updated Watchers List", res?.data?.data);
        Logger.debug("Old Watchers List", names);
        setWatchersName(res?.data?.data);
      })
      .catch((error) => {
        if (error.response?.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response?.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  },[])

  useEffect(() => {
    Logger.debug("FILE Length", files.length);
    if (files.length > 0) {
      let sizeFile = 0;
      files.map((file) => (sizeFile += file.size));
      Logger.debug("FILE SIZE", sizeFile);
      sizeFile > 5000000 ? setFileError(true) : setFileError(false);
    }
  }, [files.length]);

  useEffect(() => {
    Logger.debug("Watchers Count", ticketFormData.manager_emails.length);
    ticketFormData.manager_emails.length > 5
      ? setWatcherCount(true)
      : setWatcherCount(false);
  }, [ticketFormData.manager_emails.length]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}api/ticket/categories/`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("Response at ticketCategoriesList", res.data.data);
        Logger.debug(
          "res at ticketCategoriesList",
          res.data.data[type].categories
        );
        setCategory(res.data.data[type].categories);
      })
      .catch((error) => {
        if (error.response?.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response?.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  }, [type]);

  const queryParams = {
    id: ticketFormData.categoryData,
  };
  const params = new URLSearchParams(queryParams);

  useEffect(() => {
    if (ticketFormData.categoryData !== "") {
      axios
        .get(`${BASE_URL}api/ticket/sub_categories/?${params}`, {
          headers: { Authorization: `Bearer ${apiKey}` },
        })
        .then((res) => {
          Logger.debug("subcategories", res.data.data);
          setSubCategory(res.data.data);
        })
        .catch((error) => {
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    }
  }, [ticketFormData]);

  const cat = [
    { id: 1, countryId: 1, country: "Onbaord" },
    { id: 1, countryId: 2, country: "NewTwork" },
    { id: 3, countryId: 3, country: "other" },
  ];

  const sub = [
    { id: 1, subId: 1, subCategoryIssues: "Laptop" },
    { id: 2, subId: 2, subCategoryIssues: "Ram" },
    { id: 3, subId: 3, subCategoryIssues: "Config" },
    { id: 4, subId: 1, subCategoryIssues: "IT form" },
    { id: 5, subId: 3, subCategoryIssues: "HR " },
    { id: 6, subId: 2, subCategoryIssues: "Accrss" },
    { id: 7, subId: 1, subCategoryIssues: "access" },
    { id: 8, subId: 3, subCategoryIssues: "WIFI" },
    { id: 8, subId: 2, subCategoryIssues: "Hotspot" },
  ];

  const sla = [
    { id: 1, slaId: 1, Requiredtime: " 1" },
    { id: 2, slaId: 2, Requiredtime: " 2" },
    { id: 3, slaId: 3, Requiredtime: " 3" },
    { id: 4, slaId: 4, Requiredtime: " 4" },
    { id: 5, slaId: 5, Requiredtime: " 5" },
    { id: 6, slaId: 6, Requiredtime: " 6" },
    { id: 7, slaId: 7, Requiredtime: " 7" },
    { id: 8, slaId: 8, Requiredtime: " 8" },
    { id: 9, slaId: 9, Requiredtime: " 9" },
    { id: 10, slaId: 10, Requiredtime: "10" },
    { id: 11, slaId: 11, Requiredtime: "11" },
    { id: 12, slaId: 12, Requiredtime: "12" },
    { id: 13, slaId: 13, Requiredtime: "13" },
    { id: 14, slaId: 14, Requiredtime: "14" },
    { id: 15, slaId: 15, Requiredtime: "15" },
  ];

  const handleSubmitForm = (data) => {
    Logger.debug("FORM DATA in handleSubmitForm", data);
    if (data && fileError === false && watcherCount === false) {
      setOpen(true);

      axios
        .post(
          `${BASE_URL}api/ticket/`,
          {
            ...ticketFormData,
            files,
          },
          { headers }
        )
        .then((res) => {
          Logger.debug({ ...ticketFormData, files });
          Logger.debug("Response in ADD TICKET", res.data.data.id);
          setTicketID(res.data.data.id);
          if (res.status == 201) {
            if (files.length > 0) {
              fileUploadHandleChange(res.data.data.id);
            } else {
              setOpen(false);
              setToaster(true);
              setTitle("Success");
              setVariant("success");
              setSubTitle(
                `Ticket has been created successfully.`
              );
              setTimeout(() => {
                setToaster(false);
                navigate("/secured/ticketList");
              }, 2000);
            }
          }
        })
        .catch((error) => {
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    }
  };

  
  const CategoryHandleChange = (e) => {
    Logger.debug("RRRRRR", e);
    setTicketFormData({
      ...ticketFormData,
      categoryData: e.target.value,
    });
    const mainCatFilter = sub.filter((subValue) => {
      return subValue.subId === e.target.value;
    });
    setSubCategoryId(e.target.value);
  };

  const subCategoryDataHandleChange = (e) => {
    Logger.debug("EVENT", e);
    setTicketFormData({
      ...ticketFormData,
      sub_category: e.target.value,
    });
    const setSlaFilter = sla.filter((slaValue) => {
      return slaValue.slaId === e.target.value;
    });
    setSlaCategory(setSlaFilter);
  };

  const handleFileChange = (e) => {
    if (e.target.files.length && files.length == 0) {
      const chosenFiles = Array.prototype.slice.call(e.target.files);
      setFiles(chosenFiles);
    }
    if (e.target.files.length && files.length > 0) {
      const chosenFiles = Array.prototype.slice.call(e.target.files);
      setFiles([...files, ...chosenFiles]);
    }
  };

  const handleRemove = (indexToRemove) => {
    setFiles((prevSelectedFiles) =>
      prevSelectedFiles.filter((_, index) => index !== indexToRemove)
    );
  };

  const fileUploadHandleChange = (id) => {
    Logger.debug(files);
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      Logger.debug(files[i]);
      formData.append("attachments", files[i]);
    }
    Logger.debug("formData>>>>>", [...formData]);

    axios
      .post(`${BASE_URL}api/ticket/add_attachments/${id}/`, formData, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        Logger.debug("RESPONSE in multi upload", response);
        if (response.status == 200) {
          setOpen(false);
          setToaster(true);
          setTitle("Success");
          setVariant("success");
          setSubTitle(`Ticket has been created successfully.`);
          setTimeout(() => {
            setToaster(false);
            navigate("/secured/ticketList");
          }, 2000);
        }
      })
      .catch((error) => {
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  };

  document.title = "Add Ticket | ITSupport-Helpdesk";

  return (
    <>
      <div className="ticket_wrapper">
        <Card className="card_width">
          <Typography component="h1" variant="h5" className="!text-[22px]">
            Add Ticket
          </Typography>
          <div className="flex flex-col justify-center content_width pt-[20px]">
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col select_width mb-[8px]">
                <InputLabel
                  id="demo-simple-select-label"
                  className="mb-[5px] !text-xs !text-[#363636]"
                >
                  Subject{" "}
                  <span
                    className={
                      formik.errors.subject ? "text-red-700" : "!text-black"
                    }
                  >
                    *
                  </span>
                </InputLabel>
                <TextField
                  id="outlined-basic"
                  autoComplete="off"
                  placeholder="Type here"
                  variant="outlined"
                  type="text"
                  size="small"
                  className="w-[100%]"
                  name="subject"
                  value={ticketFormData.subject}
                  sx={{
                    input: {
                      "&::placeholder": {
                        fontSize: "14px",
                        fontFamily: "Arial, Helvetica, sans-serif !important",
                        opacity: 0.5,
                      },
                    },
                  }}
                  {...register("subject")}
                  error={
                    formik.touched.subject && Boolean(formik.errors.subject)
                  }
                  helperText={
                    !formik.errors.subject ? " " : formik.errors.subject
                  }
                  {...formik.getFieldProps("subject")}
                  onChange={(e) => {
                    Logger.debug("EVENET", e.target.value);
                    formik.handleChange(e);
                    setTicketFormData({
                      ...ticketFormData,
                      subject: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="flex select_direction justify-between mb-[8px]">
                <div className="select_width">
                  <InputLabel
                    id="demo-simple-select-label"
                    className="mb-[5px] !text-xs !text-[#363636]"
                  >
                    Type{" "}
                    <span
                      className={
                        formik.errors.requestType
                          ? "text-red-700"
                          : "!text-black"
                      }
                    >
                      *
                    </span>
                  </InputLabel>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    select
                    size="small"
                    style={{ width: "100%" }}
                    name="requestType"
                    value={ticketFormData.requestType}
                    {...register("requestType")}
                    error={
                      formik.touched.requestType &&
                      Boolean(formik.errors.requestType)
                    }
                    helperText={
                      !formik.errors.requestType
                        ? " "
                        : formik.errors.requestType
                    }
                    {...formik.getFieldProps("requestType")}
                    SelectProps={{
                      displayEmpty: true,
                      renderValue: (value) => {
                        if (value !== "") {
                          return reqType[value];
                        } else {
                          return (
                            <span className="dropdown_placeholder">
                              Select ticket type
                            </span>
                          );
                        }
                      },
                    }}
                    onChange={(e) => {
                      Logger.debug("EVENT", e.target.value);
                      formik.handleChange(e);
                      setTicketFormData({
                        ...ticketFormData,
                        requestType: e.target.value,
                      });
                      formik.setFieldValue("category", "");
                      formik.setFieldValue("subCategory", "");
                      setType(Number(e.target.value));
                      setcategoryFlag(true);
                      setsubcategoryFlag(false);
                    }}
                  >
                    {reqType.map((req, index) => {
                      return (
                        <MenuItem key={index} value={index}>
                          {req}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </div>

                <div className="select_width">
                  <InputLabel
                    id="demo-simple-select-label"
                    className="mb-[5px] !text-xs !text-[#363636]"
                  >
                    Category{" "}
                    <span className={formik.errors.category && "text-red-700"}>
                      *
                    </span>
                  </InputLabel>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    select
                    size="small"
                    style={{ width: "100%" }}
                    name="categoryData"
                    value={ticketFormData.categoryData}
                    {...register("category")}
                    error={
                      formik.touched.category && Boolean(formik.errors.category)
                    }
                    disabled={!categoryFlag?true:false}
                    helperText={
                      !formik.errors.category ? " " : formik.errors.category
                    }
                    {...formik.getFieldProps("category")}
                    SelectProps={{
                      displayEmpty: true,
                      renderValue: (value) => {
                        if (value !== "") {
                          return category.find((item) => item.id == value).name;
                        } else {
                          return (
                            <span className="dropdown_placeholder">
                              Select ticket category
                            </span>
                          );
                        }
                      },
                    }}
                    onChange={(e) => {
                      formik.handleChange(e);
                      CategoryHandleChange(e);
                      formik.setFieldValue("subCategory", "");
                      setsubcategoryFlag(true)
                    }}
                  >
                    {category.map((caterogryList) => {
                      return (
                        <MenuItem
                          key={caterogryList.id}
                          value={caterogryList.id}
                        >
                          {caterogryList.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </div>
              </div>
              <div className="flex select_direction justify-between mb-[8px]">
                <div className="select_width">
                  <InputLabel
                    id="demo-simple-select-label"
                    className="mb-[5px] !text-xs !text-[#363636]"
                  >
                    Sub-Category{" "}
                    <span
                      className={formik.errors.subCategory && "text-red-700"}
                    >
                      *
                    </span>
                  </InputLabel>

                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    select
                    size="small"
                    style={{ width: "100%" }}
                    name="sub_category"
                    value={ticketFormData.sub_category}
                    {...register("subCategory")}
                    error={
                      formik.touched.subCategory &&
                      Boolean(formik.errors.subCategory)
                    }
                    disabled={!subcategoryFlag?true:false}
                    helperText={
                      !formik.errors.subCategory
                        ? " "
                        : formik.errors.subCategory
                    }
                    {...formik.getFieldProps("subCategory")}
                    SelectProps={{
                      displayEmpty: true,
                      renderValue: (value) => {
                        if (value !== "") {
                          return subCategory.find((item) => item.id == value)
                            .name;
                        } else {
                          return (
                            <span className="dropdown_placeholder">
                              Select ticket sub-category
                            </span>
                          );
                        }
                      },
                    }}
                    onChange={(e) => {
                      formik.handleChange(e);
                      subCategoryDataHandleChange(e);
                    }}
                  >
                    {subCategory.map((val) => {
                      return (
                        <MenuItem key={val.id} value={val.id}>
                          {val.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </div>
                <div className="select_width">
                  <InputLabel
                    id="demo-simple-select-label"
                    className="mb-[5px] !text-xs !text-[#363636]"
                  >
                    Severity{" "}
                    <span className={formik.errors.severity && "text-red-700"}>
                      *
                    </span>
                  </InputLabel>

                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    select
                    size="small"
                    style={{ width: "100%" }}
                    name="severity"
                    value={ticketFormData.severity}
                    {...register("severity")}
                    error={
                      formik.touched.severity && Boolean(formik.errors.severity)
                    }
                    helperText={
                      !formik.errors.severity ? " " : formik.errors.severity
                    }
                    {...formik.getFieldProps("severity")}
                    SelectProps={{
                      displayEmpty: true,
                      renderValue: (value) => {
                        if (value !== "") {
                          return value;
                        } else {
                          return (
                            <span className="dropdown_placeholder">
                              Select ticket severity
                            </span>
                          );
                        }
                      },
                    }}
                    onChange={(e) => {
                      formik.handleChange(e);
                      setTicketFormData({
                        ...ticketFormData,
                        severity: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={"High"}>High</MenuItem>
                    <MenuItem value={"Medium"}>Medium</MenuItem>
                    <MenuItem value={"Low"}>Low</MenuItem>
                  </TextField>
                </div>
              </div>
              <div className="flex select_direction justify-between mb-[8px]">
                <div className="select_width">
                  <InputLabel
                    id="demo-simple-select-label"
                    className="mb-[5px] !text-xs !text-[#363636]"
                  >
                    NoteBook Name{" "}
                    <span className={formik.errors.hostName && "text-red-700"}>
                      *
                    </span>
                  </InputLabel>

                  <TextField
                    id="outlined-basic"
                    autoComplete="off"
                    variant="outlined"
                    type="text"
                    size="small"
                    style={{ width: "100%" }}
                    name="host_name"
                    placeholder="eg.(NB-22-097)"
                    sx={{
                      input: {
                        "&::placeholder": {
                          fontSize: "14px",
                          fontFamily: "Arial, Helvetica, sans-serif !important",
                          opacity: 0.5,
                        },
                      },
                    }}
                    value={ticketFormData.host_name}
                    {...register("hostName")}
                    error={
                      formik.touched.hostName && Boolean(formik.errors.hostName)
                    }
                    helperText={
                      !formik.errors.hostName ? " " : formik.errors.hostName
                    }
                    {...formik.getFieldProps("hostName")}
                    onChange={(e) => {
                      formik.handleChange(e);
                      setTicketFormData({
                        ...ticketFormData,
                        host_name: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="select_width">
                  <InputLabel
                    id="demo-simple-select-label"
                    className="mb-[5px] !text-xs !text-[#363636]"
                  >
                    Watchers
                  </InputLabel>
                  <Autocomplete
                    disablePortal
                    multiple
                    id="combo-box-demo"
                    options={watchersList}
                    size="small"
                    style={{ width: "100%" }}
                    name="manager_emails"
                    onChange={(e, value) => {
                      // formik.setFieldValue("watchersEmail", value);
                      Logger.debug("EVENT IN AUTOCOMPLETE", value);
                      setTicketFormData({
                        ...ticketFormData,
                        manager_emails: value,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select your Reporting Manager, Supervisor, or any Team Member."
                        name="manager_emails"
                        value={ticketFormData.manager_emails}
                      // {...register("watchersEmail")}
                      // error={
                      // ticketFormData?.manager_emails?.length==0 ?"":formik.touched.watchersEmail &&
                      // Boolean(formik.errors.watchersEmail)
                      // }
                      // helperText={
                      //   !formik.errors.watchersEmail
                      //     ? " "
                      //     : formik.errors.watchersEmail
                      // }
                      // {...formik.getFieldProps("watchersEmail")}
                      />
                    )}
                  />
                  {watcherCount && (
                    <p className="file_comment">
                      Maximum 5 member can be added as watcher
                    </p>
                  )}
                </div>
              </div>
              <div className="mb-[20px]">
                <InputLabel
                  id="demo-simple-select-label"
                  className="mb-[5px] !text-xs !text-[#363636]"
                >
                  Description about ticket{" "}
                  <span className={formik.errors.description && "text-red-700"}>
                    *
                  </span>
                </InputLabel>

                <TextField
                  multiline
                  id="outlined-basic"
                  autoComplete="off"
                  placeholder="The description comes here..."
                  variant="outlined"
                  type="text"
                  size="small"
                  style={{ width: "100%" }}
                  name="description"
                  sx={{
                    textArea: {
                      "&::placeholder": {
                        fontSize: "14px",
                        fontFamily: "Arial, Helvetica, sans-serif !important",
                        opacity: 0.6,
                      },
                    },
                  }}
                  value={ticketFormData.description}
                  {...register("description")}
                  error={
                    formik.touched.description &&
                    Boolean(formik.errors.description)
                  }
                  helperText={
                    !formik.errors.description ? " " : formik.errors.description
                  }
                  {...formik.getFieldProps("description")}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setTicketFormData({
                      ...ticketFormData,
                      description: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="flex flex-col items-center justify-start">
                <div className="w-[100%] mb-[20px]">
                  <input
                    className="w-[100%] m-[0px]"
                    type="file"
                    id="file_upload"
                    multiple
                    onChange={handleFileChange}
                    hidden
                  />
                  <label htmlFor="file_upload" className="upload_title">
                    {" "}
                    + Add Files
                  </label>
                </div>
              </div>
              {fileError ? (
                <p className="file_comment">
                  File size should not be greater than 5MB
                </p>
              ) : (
                <p className="file_comment !text-slate-500">
                  Note : File size should not be greater than 5MB
                </p>
              )}
              {files.length > 0 && (
                <div>
                  {files.map((file) => (
                    <div style={{ fontSize: "14px", marginBottom: "10px" }}>
                      {file.name}
                      <span
                        className="remove_file"
                        onClick={() => handleRemove(files.indexOf(file))}
                      >
                        X
                      </span>
                    </div>
                  ))}
                </div>
              )}

              <div className="mt-[10px] flex flex-row justify-end">
                <Button
                  type="submit"
                  variant="contained"
                  className="success-btn h-[40px]"
                  sx={{
                    textTransform: "capitalize",
                    borderRadius: 1,
                    color: "#fff",
                    backgroundColor: "#F05E67",
                    border: "1px solid #F05E67",
                    "&:hover": {
                      color: "#fff",
                      backgroundColor: "#F05E67",
                      border: "1px solid #F05E67",
                      opacity: 0.7,
                    },
                  }}
                >
                  Add Ticket
                </Button>
              </div>
            </form>
          </div>

          {toaster ? (
            <CustomToaster
              title={title}
              subTitle={subTitle}
              variant={variant}
            ></CustomToaster>
          ) : (
            <></>
          )}
          {open ? (
            <SimpleBackdrop open={open} setOpen={setOpen}></SimpleBackdrop>
          ) : (
            <></>
          )}
        </Card>
      </div>
    </>
  );
};

export default AddTicketForm;
